import * as yup from "yup";
import { PriceModes } from "./types";
import { DefaultThemeValueType } from "../../../../styled";

export const markupSchema = yup
  .object({
    markup: yup.string().required(),
  })
  .required();

export const convertPriceModeToText = (price_mode: PriceModes) => {
  let returnValue = "";
  switch (price_mode) {
    case PriceModes.WHITE:
      returnValue = "priceMode.whiteMode.title";
      break;

    case PriceModes.GREEN:
      returnValue = "priceMode.greenMode.title";
      break;

    case PriceModes.ORANGE:
      returnValue = "priceMode.orangeMode.title";
      break;

    default:
      break;
  }
  return returnValue;
};

export const priceModeColor = (
  price_mode: PriceModes,
  isSelected?: boolean,
  isTablet?: boolean
): DefaultThemeValueType => {
  if (isSelected && isTablet) return "option-cont-active";

  switch (price_mode) {
    case PriceModes.GREEN:
      return "success-01";
    case PriceModes.ORANGE:
      return "warn-01";
    default:
      return "core-04";
  }
};

export const getTitleFromProductMarkupType = (name: string) => {
  let title = "";
  switch (name) {
    case "jewelry":
      title = "priceMode.productWiseMarkup.jewelry.title";
      break;
    case "lab_grown":
      title = "priceMode.productWiseMarkup.labgrownDiamonds.title";
      break;
    case "gemstone":
      title = "priceMode.productWiseMarkup.gemstone.title";
      break;
    case "diamond":
      title = "priceMode.productWiseMarkup.naturalDiamonds.title";
      break;
    default:
      title = "priceMode.productWiseMarkup.naturalDiamonds.title";
      break;
  }
  return title;
};

export const markupAmountTrimmed = (amount: string, markupUnit: string) => {
  return amount.replace(markupUnit, "").trim();
};

export const markupAmount = (amount: string, markupUnit: string) => {
  if (amount) {
    let intAmount = markupAmountTrimmed(amount, markupUnit);
    let decimalPart =
      typeof intAmount === "string" && intAmount.toString().split(".")[1];
    const decimalCount = decimalPart ? decimalPart.length : 2;
    intAmount = (
      typeof intAmount === "string" ? parseFloat(intAmount) : intAmount
    ).toFixed(decimalCount);
    if (markupUnit === "X" || markupUnit === "x") {
      return markupUnit + " " + intAmount;
    }
    return intAmount + markupUnit;
  }
  return "";
};
